import React from 'react';
import { ProductDetail } from '../../../types/ProductTypes';
import { SectionCard, SectionTitle } from '../../Section.styles';
import { MSDSItem, MSDSInfo } from './MaterialSafetyDataSheetsSection.styles';
import { formatDateTime } from '../../../../utils/dateFormatters';

interface MaterialSafetyDataSheetsSectionProps {
    msds: ProductDetail['materialSafetyDataSheets'];
}

const MaterialSafetyDataSheetsSection: React.FC<MaterialSafetyDataSheetsSectionProps> = ({ msds }) => {
    if (!msds || msds.length === 0) {
        return null;
    }

    return (
        <SectionCard>
            <SectionTitle>Material Safety Data Sheets</SectionTitle>
            {msds.map((msdsItem) => (
                <MSDSItem key={msdsItem.id}>
                    <MSDSInfo>
                        <h4>{msdsItem.filePath}</h4>
                        {msdsItem.version && <span>Version: {msdsItem.version}</span>}
                        {msdsItem.date && <span>Date: {new Date(msdsItem.date).toLocaleDateString()}</span>}
                        <span>Updated: {formatDateTime(msdsItem.lastUpdatedUtc)}</span>
                    </MSDSInfo>
                    {msdsItem.comments && <p>{msdsItem.comments}</p>}
                </MSDSItem>
            ))}
        </SectionCard>
    );
};

export default MaterialSafetyDataSheetsSection;
